import React, { useEffect, useState } from "react";
import { fetchMisCompras } from "../services/api";
import { formatPrice } from "../utils/format";

const BADGE = {
  PENDIENTE:  { bg: "#fef9c3", color: "#854d0e" },
  PAGADO:     { bg: "#dcfce7", color: "#166534" },
  FALLIDO:    { bg: "#fee2e2", color: "#991b1b" },
  ENVIADO:    { bg: "#dbeafe", color: "#1e40af" },
  FINALIZADO: { bg: "#f3e8ff", color: "#6b21a8" },
};

function Badge({ texto }) {
  const st = BADGE[texto] || { bg: "#f1f5f9", color: "#334155" };
  return (
    <span style={{
      backgroundColor: st.bg, color: st.color,
      padding: "2px 10px", borderRadius: 12, fontSize: 12, fontWeight: 600,
    }}>
      {texto}
    </span>
  );
}

function MisCompras() {
  const [ventas,  setVentas]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState("");
  const [abierto, setAbierto] = useState(null);

  useEffect(() => {
    fetchMisCompras()
      .then(res => setVentas(res.data))
      .catch(() => setError("No se pudo cargar el historial de compras."))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p style={{ textAlign: "center", marginTop: 40 }}>Cargando compras...</p>;
  if (error)   return <p style={{ color: "red", textAlign: "center" }}>{error}</p>;

  return (
    <div style={st.contenedor}>
      <h2>📦 Mis Compras</h2>

      {ventas.length === 0 ? (
        <p>No tienes compras registradas.</p>
      ) : (
        ventas.map(v => (
          <div key={v.id} style={st.tarjeta}>
            {/* Encabezado de la venta */}
            <div style={st.encabezado} onClick={() => setAbierto(abierto === v.id ? null : v.id)}>
              <div>
                <span style={st.pedidoNum}>Pedido #{v.id}</span>
                <span style={{ fontSize: 13, color: "#666", marginLeft: 12 }}>
                  {v.fechaVenta ? new Date(v.fechaVenta).toLocaleDateString("es-CL") : "—"}
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <Badge texto={v.estadoPago}  />
                <Badge texto={v.estadoEnvio} />
                <span style={{ fontSize: 16, color: "#888" }}>{abierto === v.id ? "▲" : "▼"}</span>
              </div>
            </div>

            {/* Detalle expandible */}
            {abierto === v.id && (
              <div style={st.detalle}>
                {/* Productos */}
                <h4 style={st.subtitulo}>🛒 Productos</h4>
                <div style={{ overflowX: "auto" }}>
                <table style={st.tabla}>
                  <thead>
                    <tr style={st.thead}>
                      <th>Producto</th>
                      <th>Cantidad</th>
                      <th>Precio unit.</th>
                      <th>Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {v.detalles?.map((d, i) => (
                      <tr key={i} style={st.fila}>
                        <td>{d.producto?.nombre || "—"}</td>
                        <td>{d.cantidad}</td>
                        <td>${formatPrice(d.precioUnitario)} + IVA</td>
                        <td>${formatPrice(d.cantidad * d.precioUnitario)} + IVA</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </div>
                <p style={{ textAlign: "right", fontWeight: 700, marginTop: 8 }}>
                  Total: ${formatPrice(v.total)} + IVA
                </p>

                {/* Datos de envío */}
                <h4 style={st.subtitulo}>🚚 Datos de envío</h4>
                <div style={st.grid}>
                  <Dato label="Nombre"    valor={`${v.nombreCliente || ""} ${v.apellidoCliente || ""}`.trim()} />
                  <Dato label="RUT"       valor={v.rutCliente} />
                  <Dato label="Email"     valor={v.email} />
                  <Dato label="Teléfono"  valor={v.telefono} />
                  <Dato label="Dirección" valor={v.direccion} />
                  <Dato label="Comuna"    valor={v.comuna} />
                  <Dato label="Ciudad"    valor={v.ciudad} />
                </div>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

function Dato({ label, valor }) {
  return (
    <div style={{ marginBottom: 4 }}>
      <span style={{ fontWeight: 600, fontSize: 12, color: "#666" }}>{label}: </span>
      <span style={{ fontSize: 13 }}>{valor || "—"}</span>
    </div>
  );
}

const st = {
  contenedor: { maxWidth: 860, margin: "0 auto", padding: "24px 16px" },
  tarjeta:    { border: "1px solid #e5e7eb", borderRadius: 8, marginBottom: 16, overflow: "hidden" },
  encabezado: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "12px 16px", backgroundColor: "#f8fafc", cursor: "pointer",
  },
  pedidoNum:  { fontWeight: 700, fontSize: 15 },
  detalle:    { padding: "16px" },
  subtitulo:  { margin: "0 0 8px", fontSize: 14, color: "#374151" },
  tabla:      { width: "100%", borderCollapse: "collapse", fontSize: 13, marginBottom: 4 },
  thead:      { backgroundColor: "#1a1a2e", color: "#fff" },
  fila:       { borderBottom: "1px solid #f0f0f0" },
  grid:       { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px 16px" },
};

// Estilos de celdas
const styleEl = document.createElement("style");
styleEl.textContent = ".mis-compras-tabla td, .mis-compras-tabla th { padding: 6px 10px; text-align: left; }";
document.head.appendChild(styleEl);

export default MisCompras;
